import React, { CSSProperties } from 'react';

export const TooltipStatic = ({ withArrow = true }: { withArrow: boolean }) => {
  const tooltipStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    position: withArrow ? 'absolute' : 'static',
    top: 8,
    right: -185,
  };

  const tooltipBoxStyle: CSSProperties = {
    backgroundColor: '#43A9DE',
    color: '#fff',
    fontFamily: 'Sintony, sans-serif',
    fontSize: 12,
    padding: '6px',
    borderRadius: '5px',
    position: 'relative',
    zIndex: 1,
    ...(withArrow ? { marginLeft: '10px' } : { marginTop: '6px' }),
  };

  const tooltipArrowStyle: CSSProperties = {
    width: 0,
    height: 0,
    borderTop: '5px solid transparent',
    borderBottom: '5px solid transparent',
    borderRight: '5px solid #43A9DE',
    position: 'absolute',
    left: '6px',
  };

  return (
    <div style={tooltipStyle}>
      {withArrow && <div style={tooltipArrowStyle}></div>}
      <div style={tooltipBoxStyle}>Save More with Annual Plan</div>
    </div>
  );
};
